import React, { useEffect, useRef, useState } from "react";
import Highcharts, { HeatmapModule } from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Avatar, Box, Divider, Grid2, List, ListItem, ListItemAvatar, ListItemIcon, ListItemText, MenuItem, Select, Typography, useTheme } from "@mui/material";

function stringToColor(string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
}

function stringAvatar(name: string) {
    return {
        sx: {
            bgcolor: stringToColor(name),
        },
        children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
    };
}

const MonthlyHighlights = () => {

    return (
        <Box sx={{ padding: 2, border: '1px solid #2525252E', borderRadius: '7px',background:"#FFFFFF",minHeight:"470px" }}>
            <Grid2 container>
                <Grid2 size={{ xs: 12, md: 12 }}>
                    <Typography variant="h6" sx={{ fontWeight: "500", fontSize: '18px', color: `#182A4E`, lineHeight: '100%', letterSpacing: '-0.4px' }}>
                        Monthly Highlights
                    </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 12 }} sx={{ mt: 1 }}>
                    <Typography variant="caption" sx={{ fontWeight: "500", fontSize: '14px', color: `#182A4E80`, lineHeight: '100%', letterSpacing: '-0.4px' }}>
                        April 2025
                    </Typography>
                    <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                        <ListItem alignItems="flex-start" sx={{paddingLeft:0}}>
                            <ListItemAvatar sx={{marginTop:0}}>
                                <Avatar {...stringAvatar('I S')} sx={{
                                    backgroundColor: '#B02E2A',
                                    fontSize: '14px',
                                    fontWeight: 500,
                                    lineHeight: '100%',
                                    letterSpacing: '-0.4px',
                                    color: '#fff'
                                }} />
                            </ListItemAvatar>
                            <ListItemText
                                primary={
                                    <Typography sx={{
                                        fontWeight: "500", fontSize: '16px', color: `#182A4E80`, lineHeight: '100%', letterSpacing: '-0.4px'
                                    }}>
                                        <span style={{ color: '#B02E2A' }}>Issue Module:</span> Have identified <span style={{ color: '#B02E2A' }}>10 issues</span> this month which has a Time Impact of <span style={{ color: '#B02E2A' }}>65 days delay</span> and a cost impact of <span style={{ color: '#B02E2A' }}>Rs 120 Cr</span>
                                    </Typography>
                                }
                            />
                        </ListItem>
                        <ListItem alignItems="flex-start" sx={{paddingLeft:0}}>
                            <ListItemAvatar sx={{marginTop:0}}>
                                <Avatar {...stringAvatar('C L')} sx={{
                                    backgroundColor: '#415385',
                                    fontSize: '14px',
                                    fontWeight: 500,
                                    lineHeight: '100%',
                                    letterSpacing: '-0.4px',
                                    color: '#fff'
                                }} />
                            </ListItemAvatar>
                            <ListItemText
                                primary={
                                    <Typography sx={{
                                        fontWeight: "500", fontSize: '16px', color: `#182A4E80`, lineHeight: '100%', letterSpacing: '-0.4px'
                                    }}>
                                        <span style={{ color: '#415385' }}>Claims Module:</span> Have identified <span style={{ color: '#B02E2A' }}>10 Claims</span> this month which has a a total value of <span style={{ color: '#B02E2A' }}>Rs 310 Cr</span>
                                    </Typography>
                                }
                            />
                        </ListItem>
                        <ListItem alignItems="flex-start" sx={{paddingLeft:0}}>
                            <ListItemAvatar sx={{marginTop:0}}>
                                <Avatar {...stringAvatar('I S')} sx={{
                                    backgroundColor: '#B02E2A',
                                    fontSize: '14px',
                                    fontWeight: 500,
                                    lineHeight: '100%',
                                    letterSpacing: '-0.4px',
                                    color: '#fff'
                                }} />
                            </ListItemAvatar>
                            <ListItemText
                                primary={
                                    <Typography sx={{
                                        fontWeight: "500", fontSize: '16px', color: `#182A4E80`, lineHeight: '100%', letterSpacing: '-0.4px'
                                    }}>
                                        <span style={{ color: '#B02E2A' }}>Issue Module:</span> Have identified <span style={{ color: '#B02E2A' }}>10 issues</span> this month which has a Time Impact of <span style={{ color: '#B02E2A' }}>65 days delay</span> and a cost impact of <span style={{ color: '#B02E2A' }}>Rs 120 Cr</span>
                                    </Typography>
                                }
                            />
                        </ListItem>
                        <ListItem alignItems="flex-start" sx={{paddingLeft:0}}>
                            <ListItemAvatar sx={{marginTop:0}}>
                                <Avatar {...stringAvatar('I S')} sx={{
                                    backgroundColor: '#B02E2A',
                                    fontSize: '14px',
                                    fontWeight: 500,
                                    lineHeight: '100%',
                                    letterSpacing: '-0.4px',
                                    color: '#fff'
                                }} />
                            </ListItemAvatar>
                            <ListItemText
                                primary={
                                    <Typography sx={{
                                        fontWeight: "500", fontSize: '16px', color: `#182A4E80`, lineHeight: '100%', letterSpacing: '-0.4px'
                                    }}>
                                        <span style={{ color: '#B02E2A' }}>Issue Module:</span> Have identified <span style={{ color: '#B02E2A' }}>10 issues</span> this month which has a Time Impact of <span style={{ color: '#B02E2A' }}>65 days delay</span> and a cost impact of <span style={{ color: '#B02E2A' }}>Rs 120 Cr</span>
                                    </Typography>
                                }
                            />
                        </ListItem>
                        <ListItem alignItems="flex-start" sx={{paddingLeft:0}}>
                            <ListItemAvatar sx={{marginTop:0}}>
                                <Avatar {...stringAvatar('I S')} sx={{
                                    backgroundColor: '#B02E2A',
                                    fontSize: '14px',
                                    fontWeight: 500,
                                    lineHeight: '100%',
                                    letterSpacing: '-0.4px',
                                    color: '#fff'
                                }} />
                            </ListItemAvatar>
                            <ListItemText
                                primary={
                                    <Typography sx={{
                                        fontWeight: "500", fontSize: '16px', color: `#182A4E80`, lineHeight: '100%', letterSpacing: '-0.4px'
                                    }}>
                                        <span style={{ color: '#B02E2A' }}>Issue Module:</span> Have identified <span style={{ color: '#B02E2A' }}>10 issues</span> this month which has a Time Impact of <span style={{ color: '#B02E2A' }}>65 days delay</span> and a cost impact of <span style={{ color: '#B02E2A' }}>Rs 120 Cr</span>
                                    </Typography>
                                }
                            />
                        </ListItem>
                        <ListItem alignItems="flex-start" sx={{paddingLeft:0}}>
                            <ListItemAvatar sx={{marginTop:0}}>
                                <Avatar {...stringAvatar('I S')} sx={{
                                    backgroundColor: '#B02E2A',
                                    fontSize: '14px',
                                    fontWeight: 500,
                                    lineHeight: '100%',
                                    letterSpacing: '-0.4px',
                                    color: '#fff'
                                }} />
                            </ListItemAvatar>
                            <ListItemText
                                primary={
                                    <Typography sx={{
                                        fontWeight: "500", fontSize: '16px', color: `#182A4E80`, lineHeight: '100%', letterSpacing: '-0.4px'
                                    }}>
                                        <span style={{ color: '#B02E2A' }}>Issue Module:</span> Have identified <span style={{ color: '#B02E2A' }}>10 issues</span> this month which has a Time Impact of <span style={{ color: '#B02E2A' }}>65 days delay</span> and a cost impact of <span style={{ color: '#B02E2A' }}>Rs 120 Cr</span>
                                    </Typography>
                                }
                            />
                        </ListItem>
                    </List>
                </Grid2>
            </Grid2>
        </Box >
    );
};

export default MonthlyHighlights;
